var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Entri from 'entrijs';
import i18n from '../../../i18n';
import { show, hide } from '../../../util/show';
window.up.compiler('.js-custom_email_address_entri_button', (entriButton, dataSet) => {
    const loader = document.querySelector('.js-loader');
    window.up.on(entriButton, 'click', undefined, () => __awaiter(void 0, void 0, void 0, function* () {
        show(loader);
        const customEmailAddressInput = document.querySelector('.js-custom_email_address_input');
        const customEmailAddress = customEmailAddressInput === null || customEmailAddressInput === void 0 ? void 0 : customEmailAddressInput.value;
        const customEmailDomain = customEmailAddress === null || customEmailAddress === void 0 ? void 0 : customEmailAddress.split('@')[1];
        const response = yield fetch(dataSet.dnsRecordsPath);
        if (response && response.status === 200) {
            const dnsRecords = (yield response.json()).dns_records;
            const tokenResponse = yield fetch(dataSet.entriTokenPath);
            const authToken = (yield tokenResponse.json()).auth_token;
            const config = {
                applicationId: dataSet.entriApplicationId,
                token: authToken,
                userId: dataSet.publicationId,
                prefilledDomain: customEmailDomain,
                dnsRecords
            };
            hide(loader);
            Entri.showEntri(config).catch(() => {
                alert(i18n.$gettext('Something went wrong. Please try again.'));
            });
        }
        else {
            hide(loader);
            alert(i18n.$gettext('Something went wrong. Please try again.'));
        }
    }));
});
window.up.compiler('.js-custom_domain_entri_button', (entriButton, dataSet) => {
    const loader = document.querySelector('.js-loader');
    window.up.on(entriButton, 'click', undefined, () => __awaiter(void 0, void 0, void 0, function* () {
        const customDomainInput = document.querySelector('.js-custom_domain_input');
        const customDomain = customDomainInput === null || customDomainInput === void 0 ? void 0 : customDomainInput.value;
        if (!customDomain) {
            hide(loader);
            alert(i18n.$gettext('Custom domain not found.'));
            return;
        }
        show(loader);
        const tokenResponse = yield fetch(dataSet.entriTokenPath);
        const authToken = (yield tokenResponse.json()).auth_token;
        const config = {
            applicationId: dataSet.entriApplicationId,
            token: authToken,
            power: true,
            userId: dataSet.publicationId,
            prefilledDomain: customDomain,
            dnsRecords: {
                domain: [
                    {
                        type: 'A',
                        host: '@',
                        value: '{ENTRI_SERVERS}', // This will be automatically replaced by the Entri servers IPs
                        ttl: 300,
                        applicationUrl: dataSet.entriPublicationUrl,
                        powerRootPathAccess: JSON.parse(dataSet.entriRootPathAccess)
                    }
                ],
                subDomain: [
                    {
                        type: 'CNAME',
                        host: '{SUBDOMAIN}',
                        value: '{CNAME_TARGET}', // `{CNAME_TARGET}` will automatically use the CNAME target entered in the Entri dashboard
                        ttl: 300,
                        applicationUrl: dataSet.entriPublicationUrl,
                        powerRootPathAccess: JSON.parse(dataSet.entriRootPathAccess)
                    }
                ]
            }
        };
        hide(loader);
        Entri.showEntri(config);
    }));
});
